import * as React from "react";
import {
  DATA_LAKE_INTERNAL_ENABLED,
  DATALAKE_ATTRIBUTE_NAME,
  DATALAKE_ATTRIBUTES,
  DATA_LAKE_PREVIEW_NAV_ITEM,
  DATA_LAKE_EXTERNAL_SEARCH_ENABLED,
  DATA_LAKE_PREVIEW_ENABLED,
  DATA_LAKE_ENABLED
} from "data-lake/Constants";
import DataLakesPage from "data-lake/DataLakesPage";
import DataLakeBackendPage from "data-lake/data-lake-backend-config/DataLakeBackendPage";
import { isPermitted } from "util/PermissionsMixin";
import StreamDataLake from "data-lake/stream/StreamDataLake";
import DataLakeJobs from "data-lake/components/DataLakeJobs";
import dataLakeCustomColumnRenderer from "data-lake/DataLakeColumnRenderer";
import DataLakeConfigPage from "data-lake/DataLakeConfigPage";
import StreamIndexSetDataLakeWarning from "data-lake/stream/StreamIndexSetDataLakeWarning";
import DataLakeStreamDeleteWarning from "data-lake/stream/DataLakeStreamDeleteWarning";
import { fetchStreamDataLake } from "data-lake/hooks/useStreamDataLake";
import { fetchStreamDataLakeConfig } from "data-lake/hooks/useStreamDataLakeConfig";
import StreamIlluminateProcessingSection from "data-lake/stream/StreamIlluminateProcessingSection";
import validLicensePresent from "license/ValidLicensePresent";
import DataLakeQueryValidation from "data-lake/DataLakeQueryValidation";
import DataLakeJournal from "data-lake/components/DataLakeJournal";
import DataLakeStatus from "data-lake/components/DataLakeStatus";
import DataLakePreviewPage from "data-lake/preview/DataLakePreviewPage";
import App from "routing/App";
import DataLakeRoutes from "data-lake/Routes";
import DestinationPermissionAlert from "components/streams/StreamDetails/DestinationPermissionAlert";
import AppConfig from "util/AppConfig";
import DataLakeConnectorsPage from "data-lake/data-lake-connectors/DataLakeConnectorsPage";
import DataLakeRetrievalsPage from "data-lake/data-lake-retrievals/DataLakeRetrievalsPage";
import { filterCloudMenuItems } from "util/conditional/filterMenuItems";
import {
  RETRIEVABLE_STREAM_SIZE_ATTRIBUTE,
  retrievableStreamSizeColumnRenderer
} from "data-lake/streams-overview-extension/streamsOverviewExtension";
export const PAGE_NAV_TITLE = "Data Lake";
const streamOverviewTableElement = {
  attributeName: DATALAKE_ATTRIBUTE_NAME,
  group: "routing",
  attributes: [...DATALAKE_ATTRIBUTES, RETRIEVABLE_STREAM_SIZE_ATTRIBUTE],
  columnRenderers: {
    ...dataLakeCustomColumnRenderer,
    ...retrievableStreamSizeColumnRenderer
  }
};
const pageNavigation = {
  description: PAGE_NAV_TITLE,
  children: filterCloudMenuItems(
    [
      {
        description: "Overview",
        path: DataLakeRoutes.ARCHIVE.LIST,
        exactPathMatch: true,
        permissions: "data_lake:read"
      },
      {
        description: "Backend",
        path: DataLakeRoutes.BACKEND,
        exactPathMatch: true,
        permissions: "data_lake_backend_config:read"
      },
      {
        description: "Configuration",
        path: DataLakeRoutes.CONFIGURATION,
        exactPathMatch: true,
        permissions: "data_lake_backend_config:read"
      }
    ],
    [DataLakeRoutes.BACKEND]
  )
};
const ROUTES = [
  ...DATA_LAKE_EXTERNAL_SEARCH_ENABLED ? [
    {
      path: DataLakeRoutes.unqualified.CONNECTORS,
      component: DataLakeConnectorsPage,
      permissions: ["data_lake:read", "data_lake_backend_config:read"]
    },
    {
      path: DataLakeRoutes.unqualified.RETRIEVALS,
      component: DataLakeRetrievalsPage,
      permissions: "data_lake:read"
    }
  ] : [],
  ...DATA_LAKE_PREVIEW_ENABLED ? [
    {
      path: DataLakeRoutes.unqualified.PREVIEW,
      component: DataLakePreviewPage,
      parentComponent: App
    }
  ] : []
];
const INTERNAL_DATA_LAKE_ROUTES = DATA_LAKE_INTERNAL_ENABLED ? [
  {
    path: DataLakeRoutes.unqualified.ARCHIVE.LIST,
    component: DataLakesPage,
    permissions: "data_lake:read"
  },
  ...AppConfig.isCloud() ? [] : [
    {
      path: DataLakeRoutes.unqualified.BACKEND,
      component: DataLakeBackendPage,
      permissions: "data_lake_backend_config:read"
    }
  ],
  {
    path: DataLakeRoutes.unqualified.CONFIGURATION,
    component: DataLakeConfigPage,
    permissions: "data_lake_backend_config:read"
  }
] : [];
const routes = [...ROUTES, ...INTERNAL_DATA_LAKE_ROUTES];
const dataLakeExport = {
  "views.elements.validationErrorExplanation": [
    (props) => validLicensePresent() ? /* @__PURE__ */ React.createElement(DataLakeQueryValidation, { ...props }) : null
  ],
  routes,
  "components.streams.overview.tableElements": DATA_LAKE_ENABLED ? [streamOverviewTableElement] : [],
  dataLake: DATA_LAKE_INTERNAL_ENABLED ? [
    {
      ...AppConfig.isCloud() ? {} : { DataLakeJournal },
      DataLakeStatus,
      StreamDataLake: (props) => isPermitted(props.permissions, "data_lake:read") ? /* @__PURE__ */ React.createElement(StreamDataLake, null) : /* @__PURE__ */ React.createElement(DestinationPermissionAlert, { sectionName: "Data Lake" }),
      DataLakeJobs: (props) => isPermitted(props.permissions, "data_lake:read") ? /* @__PURE__ */ React.createElement(DataLakeJobs, { ...props }) : null,
      StreamIndexSetDataLakeWarning,
      fetchStreamDataLake,
      fetchStreamDataLakeStatus: fetchStreamDataLakeConfig,
      DataLakeStreamDeleteWarning,
      StreamIlluminateProcessingSection
    }
  ] : [],
  navigation: DATA_LAKE_ENABLED ? [DATA_LAKE_PREVIEW_NAV_ITEM] : [],
  pageNavigation: [pageNavigation]
};
export default dataLakeExport;
